import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { getSessionId } from '@utils/session';

const ENDPOINT_URL = '/prd-products';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetProductsInput = paths[url]['post']['parameters']['query'];
export type GetProductsSuccessResponse = paths[url]['post']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get paginated products.
 * Then saves it in Data Context.
 */
export const useGetProducts = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setProducts, setIsLoadingProducts, login } = useData();

    const request = async (props: GetProductsInput) => {
        setIsLoadingProducts(true);

        const sessionId = getSessionId();

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ ...getCommonParameters(), ...props, session_id: login === null ? sessionId : '' }),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetProductsSuccessResponse = await response.json();

            setProducts(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setIsLoadingProducts(false);
        }
    };

    return { request };
};
